import { ResponseError } from '@backstage/errors';











/**
 * Options for creating a ClusterManagementClient.
 *
 * @public
 */





/**
 * An implementation of the ClusterManagementApi that talks to the access-control-backend plugin.
 *
 * @public
 */
export class ClusterManagement  {
    identityApi;
    configApi;

  constructor(options) {
    this.identityApi = options.identityApi;
    this.configApi = options.configApi;
  }

  async getEnvironments() {
    const baseUrl = this.configApi.getString('backend.baseUrl');
    const { token } = await this.identityApi.getCredentials();

    const res = await fetch(`${baseUrl}/clustermanagement/v1/environments`, {
      method: 'GET',
      headers: token
        ? {
            Authorization: `Bearer ${token}`,
          }
        : undefined,
    });

    if (!res.ok) throw await ResponseError.fromResponse(res);
    const data = await res.json();
    return data;
  }

  async getEnvironmentApplications(params


) {
    const baseUrl = this.configApi.getString('backend.baseUrl');
    const { token } = await this.identityApi.getCredentials();
    const targetUrl = new URL(
      `${baseUrl}/clustermanagement/v1/environment-applications`,
    );
    if (params) {
      params.environmentId &&
        targetUrl.searchParams.set('environment_id', params.environmentId);
      params.applicationId &&
        targetUrl.searchParams.set('application_id', params.applicationId);
    }

    const res = await fetch(targetUrl.toString(), {
      method: 'GET',
      headers: token
        ? {
            Authorization: `Bearer ${token}`,
          }
        : undefined,
    });

    if (!res.ok) throw await ResponseError.fromResponse(res);
    return res.json();
  }

  async getApplications() {
    const baseUrl = this.configApi.getString('backend.baseUrl');
    const { token } = await this.identityApi.getCredentials();
    const res = await fetch(`${baseUrl}/clustermanagement/v1/applications`, {
      method: 'GET',
      headers: token
        ? {
            Authorization: `Bearer ${token}`,
          }
        : undefined,
    });

    if (!res.ok) throw await ResponseError.fromResponse(res);
    return res.json();
  }

  async getApplication({
    applicationId,
  }

) {
    const baseUrl = this.configApi.getString('backend.baseUrl');
    const { token } = await this.identityApi.getCredentials();

    const res = await fetch(
      `${baseUrl}/clustermanagement/v1/applications/${applicationId}`,
      {
        method: 'GET',
        headers: token
          ? {
              Authorization: `Bearer ${token}`,
            }
          : undefined,
      },
    );

    if (!res.ok) throw await ResponseError.fromResponse(res);
    return res.json();
  }

  async getMetric(environmentApplicationId) {
    const baseUrl = this.configApi.getString('backend.baseUrl');
    const { token } = await this.identityApi.getCredentials();

    const res = await fetch(
      `${baseUrl}/clustermanagement/v1/environment-applications/${environmentApplicationId}/metrics`,
      {
        method: 'GET',
        headers: token
          ? {
              Authorization: `Bearer ${token}`,
            }
          : undefined,
      },
    );

    if (!res.ok) throw await ResponseError.fromResponse(res);
    return res.json();
  }

  async getEnvironment(environmentId) {
    const baseUrl = this.configApi.getString('backend.baseUrl');
    const { token } = await this.identityApi.getCredentials();

    const res = await fetch(
      `${baseUrl}/clustermanagement/v1/environments/${environmentId}`,
      {
        method: 'GET',
        headers: token
          ? {
              Authorization: `Bearer ${token}`,
            }
          : undefined,
      },
    );

    if (!res.ok) throw await ResponseError.fromResponse(res);
    const data = await res.json();
    return data;
  }
}
